<app-header [title]="project()?.name || 'Project'"
            [description]="project()?.topic || 'Manage your project settings'">
  @if (hasPapers()) {
    <div class="toolbar-actions">
      @if (editMode()) {
        <button mat-flat-button
                (click)="createAddPaperDialog()"
                tourAnchor="add-paper-btn"
                aria-label="Open add new paper dialog">
          <mat-icon>add</mat-icon>
          <span>Add manual paper</span>
        </button>
      }

      <button mat-flat-button
              (click)="startExport()"
              tourAnchor="download-paper-btn"
              aria-label="export research dialog">
        <mat-icon>system_update_alt</mat-icon>
        <span>Download</span>
      </button>

      <a mat-flat-button
         routerLink="eval"
         aria-label="Eval Settings dialog"
      >
        <mat-icon>analytics</mat-icon>
        <span>Evaluation</span>
      </a>

      <a mat-flat-button
         routerLink="flow"
         aria-label="Open Settings dialog"
         tourAnchor="screening-results-btn"
      >
        <mat-icon>account_tree</mat-icon>
        <span>Charts</span>
      </a>

      @if (hasSettings()) {
        @if (editMode()) {
          @if (screeningRunning()) {
            <button mat-flat-button
                    class="stop-screening-btn"
                    (click)="stopScreening()"
                    aria-label="Stop screening">
              <mat-icon>book_4_spark</mat-icon>
              <span>Stop Screening</span>
            </button>
          } @else {
            <button mat-flat-button
                    [ngClass]="nextStepScreening() ? 'next-step-btn' : ''"
                    (click)="startScreening()"
                    tourAnchor="start-screening-btn"
                    aria-label="Start screening">
              <mat-icon>book_4_spark</mat-icon>
              <span>Start Screening</span>
            </button>
          }
        }
      }

      @if (editMode()) {
        <button mat-flat-button
                [ngClass]="nextStepResearch() ? 'next-step-btn' : ''"
                (click)="startResearch()"
                tourAnchor="find-paper-btn"
                matTooltip="Start a new online search"
                aria-label="start research dialog">
          <mat-icon>query_stats</mat-icon>
          <span>Online search</span>
        </button>
      }
    </div>
  }
</app-header>

@if (projectId() && hasSettings()) {
  <app-research-paper-list [projectId]="projectId()!"></app-research-paper-list>
} @else {
  @if (noKeywords()) {
    <app-empty-state
      title="No keywords found"
      icon="warning"
      subtitle="To use this page, you need to define keywords first.
          Please go to the settings to add the necessary keywords."
    >
    </app-empty-state>
  } @else {

    <app-loading-card
      class="no-settings-card"
      title="We are creating your customized search queries">
      <p>Analyzing your keywords and creating meaningful queries for you ...</p>
    </app-loading-card>
  }
}
